<app-select-produto (filtrarPorProduto)="produtoChange($event)" [disabled]="loading" [isPanel]="true"></app-select-produto>

<app-select-periodo [opcoes]="opcoesPeriodos" [disabled]="loading" (selectedChange)="periodoChange($event)"></app-select-periodo>

<app-panel noDataText="Não há dados o suficiente para exibir seu desempenho" panelTitleIcon="../../../assets/images/icons/ico_ranking.png"
    panelTitleSmall="Ranking" [panelTitle]="tituloRanking" [loading]="loading" [noData]="!isRanking">
    <div *ngIf="isRanking" class="row">
        <ol class="position-list ">
            <li *ngFor="let item of dados.listasRanking" [ngClass]="{'usuario-logado': item?.isUsuarioLogado === 'S'}">
                <span class="number text-center">{{item.posicaoRanking}}°</span>
                <span class="name">
                    <span *ngIf="item?.isUsuarioLogado === 'S';else nome">Você</span>
                    <ng-template #nome>{{item.nmLojistaOperador}}</ng-template>
                    <small>{{item.complemento}}</small>
                </span>
                <span class="position">{{item.pontuacao}}
                    <small>contratos</small>
                </span>
            </li>
        </ol>
    </div>
</app-panel>

<app-panel *ngIf="isMeuRanking" [loading]="loading" panelTitleIcon="../../../assets/images/icons/ico_rating.png" panelTitleSmall="Meu"
    panelTitle="Ranking">
    <div *ngIf="isMeuRanking">
        <div class="row">
            <ol class="position-list my_rank">
                <li>
                    <span class="number text-center">{{dados?.meuRanking?.posicaoRanking}}°</span>
                    <span class="name">Você
                        <small>{{dados?.meuRanking?.complemento}}</small>
                    </span>
                    <span class="position">{{dados?.meuRanking?.pontuacao}}
                        <small>contratos</small>
                    </span>
                </li>
            </ol>
        </div>

        <div class="user-numbers">
            <div class="indicator analysis">
                Valor total
                <span>{{dados?.meuRanking?.valorTotal || 0 | currency:'BRL':'symbol':'1.2-2'}}</span>
            </div>

            <div class="indicator approved">
                Contratos
                <span>{{dados?.meuRanking?.qtdeFichas}}</span>
            </div>

            <div class="indicator paids">
                Aprovadas
                <span>{{dados?.meuRanking?.qtdeAprovadas}}</span>
            </div>
        </div>
    </div>

    <div *ngIf="isDetalhes">
        <div class="row">
            <div class="col-xs-12">
                <h3>Detalhes</h3>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <ol class="position-list my_rank">
                    <li *ngFor="let item of dados?.detalhes">
                        <span class="number text-center">{{item.posicaoRanking}}°</span>
                        <div *ngIf="item.produto === 'MOTO'" class="container-kind bikes">
                            Motos
                        </div>
                        <div *ngIf="item.produto === 'VEÍCULO LEVE'" class="container-kind cars">
                            Veículos leves
                        </div>
                        <div *ngIf="item.produto === 'VEÍCULO PESADO'" class="container-kind trucks">
                            Veículos pesados
                        </div>
                        <div *ngIf="item.produto === 'CRÉDITO PESSOAL'" class="container-kind cp">
                            Crédito Pessoal
                        </div>
                        <div *ngIf="item.produto === 'CDC LOJA'" class="container-kind cdcl">
                            CDC Loja
                        </div>
                        <span class="position">{{item.valorTotal || 0 | currency:'BRL':'symbol':'1.2-2'}}
                            <small>{{item.totalContratos}} fichas</small>
                        </span>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</app-panel>
